import { render, staticRenderFns } from "./biDPie.vue?vue&type=template&id=a11f6fc0&"
import script from "./biDPie.vue?vue&type=script&lang=js&"
export * from "./biDPie.vue?vue&type=script&lang=js&"
import style0 from "./biDPie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports